import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';
import { sorts } from '../../utils';
import Loading from '../../components/Loading';
import { userGroups } from '../../context/AuthContext';
import Modal from '../../components/Modal';

export const USERS_LIST = gql`
    query listUsers {
        listUsers {
            sub
            email
            given_name
            family_name
            phone_number
            groups
        }
    }
`;

export const REMOVE_USER = gql`
    mutation removeUser($id: ID!) {
        deleteUser(sub: $id)
    }
`;

const UserList = () => {
    const { loading, data, refetch } = useQuery(USERS_LIST, {
        fetchPolicy: 'network-only'
    });
    const [removeUser, { loading: removing }] = useMutation(REMOVE_USER);
    const [userToDelete, setUserToDelete] = useState(null);

    let users = data?.listUsers;

    const handleRemoveUser = async () => {
        await removeUser({
            variables: {
                id: userToDelete.sub
            }
        });
        setUserToDelete(null);
        refetch();
    };

    return (
        <Layout requiresGroup={userGroups.ADMIN}>
            <div className="row middle-md mb-4">
                <div className="col-xs-12 col-md-6">
                    <h1 className="mb-0">Users</h1>
                </div>
                <div className="col-xs-12 col-md-6 txt-right">
                    <Link to="/admin/users/add" className="btn btn-secondary">
                        Add User
                    </Link>
                </div>
            </div>
            {loading && <Loading />}
            {/* {!data && !loading && <div className="flash flash-danger mt-4">Error Loading Users</div>} */}
            {users && !loading && (
                <table className="table align-middle">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Groups</th>
                            <th>Phone #</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users
                            .sort((a, b) => sorts.asc(a.family_name, b.family_name))
                            .map((user) => (
                                <tr key={user.sub}>
                                    <td>{user.sub}</td>
                                    <td>
                                        {user.given_name} {user.family_name}
                                    </td>
                                    <td>{user.email}</td>
                                    <td>{user.groups.join(', ')}</td>
                                    <td>{user.phone_number}</td>
                                    <td className="txt-center">
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => setUserToDelete(user)}
                                            disabled={removing}
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            )}
            <Modal
                visible={!!userToDelete}
                onClose={() => setUserToDelete(null)}
                label="Confirm Delete User"
                center
            >
                <h3>Remove User</h3>
                <p>
                    Are you sure you want to remove{' '}
                    <strong>
                        {userToDelete?.given_name} {userToDelete?.family_name}
                    </strong>
                    ? This action cannot be undone.
                </p>
                <div className="row end-xs mt-4">
                    <div className="col">
                        <button
                            className="btn btn-secondary mr-2"
                            onClick={() => setUserToDelete(null)}
                            disabled={removing}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={handleRemoveUser}
                            disabled={removing}
                        >
                            {removing ? 'Removing...' : 'Remove'}
                        </button>
                    </div>
                </div>
            </Modal>
        </Layout>
    );
};

export default UserList;
